import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CartService } from '@shared/services/cart.service';
import { UiStateService } from '@shared/services/ui-state.service';
import { LocaleService } from '@shared/services/locale.service';

interface CategoryLink { zh: string; en: string; href: string; }

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
  cartItemNum$: Observable<number>;

  readonly categoryLinks: CategoryLink[] = [
    { zh: $localize`:@@nav.cat.puff:西樹泡芙`,       en: 'Puff',        href: '#/products/40' },
    { zh: $localize`:@@nav.cat.mochi:麻糬`,          en: 'Mochi',       href: '#/products/39' },
    { zh: $localize`:@@nav.cat.promo:推廣產品`,      en: 'Promotional', href: '#/products/88' },
    { zh: $localize`:@@nav.cat.partyset:派對套餐`,   en: 'Party Set',   href: '#/products/87' },
    { zh: $localize`:@@nav.cat.coupon:禮券`,         en: 'Coupon',      href: '#/products/89' }
  ];

  constructor(private cartService: CartService, private uiState: UiStateService, public locale: LocaleService) {}

  ngOnInit(): void {
    this.cartItemNum$ = this.cartService.cartItemNum$;
  }

  onHamburgerClick(): void {
    this.uiState.openDrawer();
  }
}
